import React from "react";

function Logo(){
    return <div className="">
    <img src="/assets/logoSvg.svg" className="object-cover  w-[5rem]" alt="logo"></img>
    <p className="cinzel font-bold text-[#56736D] absolute top-[1rem] left-[5rem]">Karishma's Closet </p>
    <p className=" text-[#56736D] cinzel top-[2.5rem] text-[0.7rem] left-[8rem] font-bold absolute">Since 2016</p>
    </div>;
}

export default Logo;